import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class CInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (req.url.indexOf('/api/') !== -1) {
            const newUrl =
                environment.server === 60
                    ? !environment.production && req.url[0] === '/'
                        ? environment.API_BASE_URL + req.url
                        : req.url // study.devel.uz
                    : environment.production && req.url[0] === '/'
                    ? environment.API_BASE_URL + req.url
                    : req.url; // online.piima.uz

            var lang = localStorage.getItem('defaultLang');
            if (lang) {
                lang = <string>lang;
            } else {
                lang = environment.defaultLang;
            }
            //Конвертация в международный стандарт
            switch (lang) {
                case 'ru':
                    lang = 'ru-Ru';
                    break;
                case 'en':
                    lang = 'en-US';
                    break;
                case 'uz':
                    lang = 'uz-Latn-UZ';
                    break;
                case 'kr':
                    lang = 'kk-KZ';
            }
            req = req.clone({
                url: newUrl,
                setHeaders: { 'Accept-Language': lang },
                withCredentials: false,
            });
        }
        //}
        return next.handle(req);
    }
}
